module.exports = __webpack_public_path__ + "fcc03a3267450c2457b9410b0578b5fb.svg";